<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar">
			<span class="h-panel-title">提现明细</span>
			<div class="hbtnbox">
				<button class="h-btn h-btn-blue">导出</button>
				<!-- <button class="h-btn">打印</button> -->
			</div>
		</div>
		<div class="partnerBox"  >
			<div class="filterbox"> 
				<div class="filterdatebox">
					<a-range-picker :locale="locale"  @change="onChange" />
				</div> 
				<div>
					<span style="padding-left:20px;font-weight:normal;padding-right:15px;">服务人员昵称</span>
					 <a-input placeholder="输入搜索内容" style="width:150px;" v-model="queryObj.name"  />
					<span style="padding-left:20px;font-weight:normal;padding-right:15px;">是否结算</span>
					<a-select v-model="queryObj.balanceState" style="width: 120px">
						<a-select-option   :value="0">全部</a-select-option>
                        <a-select-option   :value="-1">未结算</a-select-option>
                        <a-select-option   :value="1">已结算</a-select-option>
					</a-select>
					
					<a-button type="primary" style="margin-left:20px;" @click="gosearch">
						查询
					</a-button>
				</div>
			</div>
	  
			<div class="tablessbox"> 
				<table class="tableorderlist">
					<tr class="headtr">					
						<td style="text-align:center;">服务人员昵称</td>
						<td style="text-align:center;">服务人员手机号</td>
						<td style="text-align:center;">银行卡收款人姓名</td>
						<td style="text-align:center;">银行卡号</td>
						<td style="text-align:center;">开户银行</td>
						<td style="text-align:center;">开户支行</td>
						<td style="text-align:center;">手机号码</td>
						<td style="text-align:center;">提现金额</td>
						<td style="text-align:center;">申请时间</td>
						<td style="text-align:center;">审核状态</td>
						<td style="text-align:center;">审核时间</td>
						<td style="text-align:center;">结算状态</td>
					</tr>
					<tbody v-if="orderrecord.length>0">
					<tr v-for="(item,index) in orderrecord" :key="index">
						<td style="width:100px;text-align:center;"><span>{{item.waiterName}}</span></td>
						<td style="width:100px;text-align:center;"><span>{{item.waiterPhone}}</span></td>
						<td style="width:100px;text-align:center;"><span>{{item.bankUserName}}</span></td>
						<td style="width:150px;text-align:center;"><span>{{item.bankCard}}</span></td>
						<td style="width:100px;text-align:center;"><span>{{item.bankName}}</span></td>
						<td style="width:120px;text-align:center;"><span>{{item.subbranchName}}</span></td>
						<td style="width:80px;text-align:center;"><span>{{item.bankPhone}}</span></td>
						<td style="width:60px;text-align:center;"><span>{{item.amount}}</span></td>
						<td style="width:60px;text-align:center;"><span>{{item.reportTime}}</span></td>
						<td style="width:80px;text-align:center;">
                            <span>{{item.auditState==-1?"未审核":item.auditState==1?"审核通过":item.auditState==2?"审核未通过":"-"}}</span>
                        </td>
						<td style="width:60px;text-align:center;"><span>{{item.auditTime}}</span></td>
                        <td style="width:70px;text-align:center;">
                            <span>{{item.auditState==-1?"未结算":item.auditState==1?"已结算":"-"}}</span>
                        </td>
					</tr>
				</tbody>	
					<tr v-else>
						<td colSpan="12" style="text-align:center;padding-top:80px;padding-bottom:100px;border:none;">没有数据！</td>
					</tr>	
				</table> 

				<div class="yema" v-show="orderrecord.length>0">
					<a-pagination
						v-model="current"
						:total="total"
						:page-size="pageSize" >
						<template slot="buildOptionText" slot-scope="props">
						<span v-if="props.value !== '50'">{{ props.value }}条/页</span>
						<span v-if="props.value === '50'">全部</span>
						</template>
					</a-pagination>
				</div>
			</div>
		</div> 
	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
 
 

import { mapState } from 'vuex';
export default {
	name: "Salarymanage",
	data() {
		return {
			dataList: {}, 
			locale,  
			titletally:{}, 
			moment,
			depparam:[],
            queryObj:{
                name:'',
                balanceState:0,
                startTime:undefined,
                endTime:undefined
            },
			selparams:{
				departId:'',
				size:50,
				accountSetsId:'',
				state:1,
			},
			datas:[],
			dqdepss:'',
			seltitleTally:{
				accountSetsId:'',
				startTime:'',
				endTime:'',
				personId:'',
				departId:''
			},
			departmentlist:[], //部门
			orderrecord:[],
			orderrecord2:[],
			current: 1, //页码
			pageSize: 10,
			total: 50

		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		date() {
			return moment(this.accountDate);
		}
	},
	methods: {

		//列表
		listQuery(){
            var that =this;
            var accountSetsId = this.User.accountSetsId;
			if(this.queryObj.startTime=='' || this.queryObj.endTime==''){ 
				var parmas = {
					accountSetsId, 
					current:1,
					size:10,
					balanceState:this.queryObj.balanceState,
					name:this.queryObj.name
				} 
			}else{ 
				var parmas = {
					accountSetsId, 
					current:1,
					size:10,
					startTime:this.queryObj.startTime,
					endTime:this.queryObj.endTime,
                    balanceState:this.queryObj.balanceState,
					name:this.queryObj.name
				}

			}
            console.log("参数：")
            console.log(parmas)

            this.$api.community.waiterCashOutList(parmas).then(res=>{				
				if(res.code==200){
					that.orderrecord = res.data.records;
					that.current = res.data.current;
					that.total = res.data.pages;
				}
				//console.log('9999',res);

			})

        },
		//时间选择	
		onChange(date, dateString) {
			this.queryObj.startTime = dateString[0];
			this.queryObj.endTime = dateString[1];
			this.size = '';  
		},
		//快捷时间点
		changeday(e){
			//console.log('e',e.target.value);
			this.size = e.target.value;
			var value = e.target.value;
			//获取完整的日期
			var date = new Date(); 
			//获取当前年份：
			var year = date.getFullYear(); 
			//获取当前月份：
			var month = date.getMonth() + 1;
			//获取当前日：
			var day = date.getDate();

			if(value=='today'){

				var time = this.getDay(0);
				console.log('time',time);

				this.seltitleTally.startTime = time;
				this.seltitleTally.endTime = time;


			}else if(value=='yesterday'){

				var time = this.getDay(-1);
				console.log('time',time);

				this.seltitleTally.startTime = time;
				this.seltitleTally.endTime = time;


			}else if(value=='7days'){

				var days7 = this.getDay(-7);
				var time = this.getDay(0);
				this.seltitleTally.startTime = days7;
				this.seltitleTally.endTime = time;


			}else if(value=='30days'){

				var days30 = this.getDay(-30);
				var time = this.getDay(0);
				this.seltitleTally.startTime = days30;
				this.seltitleTally.endTime = time;


			}else if(value=='thismonth'){

				month = (month > 9) ? month : ("0" + month);
				var theday = year + "-" + month + "-" + '01';
				this.seltitleTally.startTime = theday;
				this.seltitleTally.endTime = time;


			}else if(value=='lastmonth'){
				this.seltitleTally.startTime = this.getLastMonthFirstDay();
				this.seltitleTally.endTime = this.getLastMonthAndDay();

			}else if(value=='whole'){

				this.seltitleTally.startTime = '';
				this.seltitleTally.endTime = '';

			}
 

		},
		
		//获取某一天
		getDay(day) {
                var today = new Date();
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
                today.setTime(targetday_milliseconds); //注意，这行是关键代码                
                var tYear = today.getFullYear();
                var tMonth = today.getMonth();
                var tDate = today.getDate();
                tMonth = this.doHandleMonth(tMonth + 1);
                tDate = this.doHandleMonth(tDate);
                return tYear + "-" + tMonth + "-" + tDate;
		},
		doHandleMonth(month) {
                var m = month;
                if (month.toString().length == 1) {
                    m = "0" + month;
                };
                return m;
		},
		//获取上个月第一天
		getLastMonthFirstDay() {
				var date = new Date();
				date.setDate(0);
				var y = date.getFullYear(); //获取年份
				var m = date.getMonth() + 1; //获取月份
				m = m < 10 ? "0" + m : m; //月份补 0
				return [y, m, '01'].join("-");
		},
		//获取上个月最后一天
		getLastMonthAndDay(){
			var nowDate = new Date();
			var year = nowDate.getFullYear();
			var month = nowDate.getMonth();
			if(month == 0){
				month = 12;
				year = year - 1;
			}
			var lastDay = new Date(year,month,0);
			month = (month > 9) ? month : ("0" + month);
			var yyyyMMdd = year+"-"+month+"-"+lastDay.getDate();
			return yyyyMMdd;
		},
		//查询
		gosearch(){
			 this.listQuery();
		}

	},

	mounted() {
        this.listQuery();
		
	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}
}

.h-panel-body {
	min-width: 1600px;
	background: #fff;
}

.h-panel-bar {
	display: flex;
	justify-content: space-between;
}

.filterbox {
	padding-top: 20px;
	display: flex;
	justify-content: left;
	align-items: center;
	min-width: 1600px;
}

.filterbox .filtertimebox {
	padding-right: 20px;
}

.databox {
	overflow: hidden;
	padding-top: 30px;
	padding-bottom: 20px;
	padding-left: 20px;
}

.databox dl {
	float: left;
	padding-right: 100px;
}

.databox dl dt {
	font-size: 18px;
	color: #2D2D2D
}

.databox dl dd {
	font-size: 34px;
	color: #3667EF;
}


.tableorderlist{ width:100%;font-weight:none!important;}
.tableorderlist tr {font-weight:none!important;}
.tableorderlist tr td{  font-weight:normal; padding:20px 5px; border-bottom:1px solid #eee;}

.tableorderlist .headtr td{  font-weight:bold;}

 


.tablessbox{ min-height:600px;}


.tableorderlist tr td dl.rmdl{ float:left; padding-right:20px;}
.tableorderlist tr td dl.rmdl dt{ color:#1E5AEE; font-weight:bold;}

.yema{ text-align:center; padding-top:30px;}

</style>
